/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateUserTemporaryPinCodePayload } from 'api/actions/create-user-temporary-pin-code/create-user-temporary-pin-code-payload';
import { CreateUserTemporaryPinCodePathParameters } from 'api/actions/create-user-temporary-pin-code/create-user-temporary-pin-code-path-parameters';
import { CreateUserTemporaryPinCodeResponse } from 'api/actions/create-user-temporary-pin-code/create-user-temporary-pin-code-response';

type CreateUserTemporaryPinCodeQueryParameters = Record<string, any>;

/**
 * The path of the CreateUserTemporaryPinCode action.
 */
export const createUserTemporaryPinCodeActionPath = new SweetPath<keyof CreateUserTemporaryPinCodePathParameters>(
  '/user/pin/temporary',
  { path: '{param}' }
);

/**
 * Creates a contextualized CreateUserTemporaryPinCode actions.
 */
export default function createCreateUserTemporaryPinCodeAction(axios: AxiosInstance) {
  return function createUserTemporaryPinCodeAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: CreateUserTemporaryPinCodeQueryParameters;
    payload: CreateUserTemporaryPinCodePayload;
  }) {
    const path = createUserTemporaryPinCodeActionPath.original;

    return axios.post<
      CreateUserTemporaryPinCodeResponse,
      CreateUserTemporaryPinCodeResponse,
      CreateUserTemporaryPinCodePayload
    >(path, payload);
  };
}
